// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WhoCanSeePost-cls1___4be81a97646e105dd2e{/*!*/}.WhoCanSeePost-cls2___3aa4fed6506ad2207fd{font-weight:400;font-size:14px;line-height:20px;padding:6px 8px;height:-moz-min-content;height:min-content}@media(min-width: 768px){.WhoCanSeePost-cls2___3aa4fed6506ad2207fd:only-child{margin-bottom:-12px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "WhoCanSeePost-cls1___4be81a97646e105dd2e",
	"cls2": "WhoCanSeePost-cls2___3aa4fed6506ad2207fd WhoCanSeePost-cls1___4be81a97646e105dd2e"
};
export default ___CSS_LOADER_EXPORT___;
